import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import withErrorBoundary from '../../../../core/components/errors/withErrorBoundary';
import LinkBreadcrumbs from '../../../../core/components/LinkBreadcrumbs';
import type { BreadcrumbLink } from '../../../../core/components/LinkBreadcrumbs';
import useCategory from '../../../../core/queries/useCategory';
import {
    buildCategoryBreadcrumbs,
    fromRootLinkToBreadcrumbs,
} from '../../../../core/util/categories';

interface ProductListBreadcrumbsProps {
    rootLinks?: {
        text?: string;
        messageId?: string;
        to?: string;
    }[];
    title?: string;
    description?: string;
}

const ProductListBreadcrumbs = ({
    rootLinks = [],
    title,
    description,
}: ProductListBreadcrumbsProps) => {
    const { categoryData } = useCategory();
    const { search } = useLocation();

    const rootLinkBreadcrumbs = fromRootLinkToBreadcrumbs(rootLinks);
    const categoryBreadcrumbs = buildCategoryBreadcrumbs(categoryData, search);
    const breadcrumbs = [
        ...rootLinkBreadcrumbs,
        ...categoryBreadcrumbs,
    ] as BreadcrumbLink[];

    return (
        <LinkBreadcrumbs
            description={description}
            title={title}
            isBorderVisible={false}
            breadcrumbs={breadcrumbs}
            withStore={!categoryData}
        />
    );
};

export default memo(withErrorBoundary(ProductListBreadcrumbs));
